import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { QualificationStatus } from '@wilson/interfaces';
import { QualificationsUtilityService } from '@wilson/qualifications';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { OnClickRendererParams } from './confirmed-by-user-renderer';

@Component({
  selector: 'wilson-status-qualification-v2-icon-renderer',
  template: `
    <div class="cursor-pointer" (click)="onClick($event)">
      @if (cellValue === qualificationStatuses.valid) {
        <nz-tag nzColor="default">
          {{ 'page.qualifications.status.valid' | translate }}
        </nz-tag>
      } @else if (cellValue === qualificationStatuses.expired) {
        <nz-tag nzColor="error">{{
          'page.qualifications.status.expired' | translate
        }}</nz-tag>
      } @else if (cellValue === qualificationStatuses.expiresSoon) {
        <nz-tag nzColor="warning">{{
          'page.qualifications.status.expires_soon' | translate
        }}</nz-tag>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, NzTagModule],
})
export class StatusQualificationV2IconRendererComponent
  implements AgRendererComponent
{
  private qualificationsUtilService = inject(QualificationsUtilityService);

  public cellValue!: string;
  public qualificationStatuses = QualificationStatus;

  params!: OnClickRendererParams;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    if (params.data) {
      this.cellValue = this.qualificationsUtilService.getQualificationStatus(
        params.data,
      );
    }
  }

  refresh(params: ICellRendererParams): boolean {
    this.cellValue = this.qualificationsUtilService.getQualificationStatus(
      params.data,
    );
    return true;
  }

  getBadgeStatus(params: ICellRendererParams): QualificationStatus {
    return params.data.canAccessWilson;
  }

  onClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.params?.onClick) {
      this.params.onClick(event, this.params.data);
    }
  }
}
